import _class from "./class.js";
import _assignment from "./assignment.js";
import _account from "./account.js";
import _exercise from "./exercise.js";
import _blogs from "./blogs.js";
import _form from "./form.js";
import _subscription from "./subscription.js";
import _schools from "./schools.js";
import _notifications from "./notifications.js";
import _tabuleoSubscription from "./tabuleoSubscription.js";
import _garSubscription from "./garSubscription.js";
import _students from "./students.js";
import _country from "./country.js";
import _teachers from "./teachers.js";
import _payment from "./payment.js";
import _resource from "./resource.js";
import _purge from "./purge.js";
import _mockExams from "./mockExams.js";
import _twoFactorAuth from "./twoFactorAuth.js";
import _session from "./session.js";
import _maintenance from "./maintenance.js";

const message = {
  languages: {
    language: "Sprache",
    french: "Französisch",
    english: "Englisch",
    german: "German",
  },
  notes: {
    helpNotePart1:
      "Hinweis: Diese Übung enthält einen Hilfemodus, den du über die Schaltfläche neben",
    helpNotePart2:
      "jeder Frage aktivieren kannst. Achtung: Wenn du den Hilfemodus verwendest, kannst du für die Frage maximal die Hälfte der Punkte erhalten.",
  },
  bugCategories: {
    51: "Übungen",
    52: "Aufgaben",
    53: "Persönliches Konto",
  },
  admin: "Administrator",
  chapter: "Kapitel",
  subchapter: "Unterkapitel",
  talkingAboutUs: "Presseberichte",
  back: "Zurück",
  backToContents: "Zurück zur Übersicht",
  trainAgain: "Weiter üben",
  title: "Titel",
  link: "Link",
  text: "Text",
  filterBy: "Filtern nach:",
  picture: "Bild",
  keywords: "Schlüsselwörter",
  firstname: "Vorname",
  lastname: "Nachname",
  email: "E-Mail-Adresse",
  publishDate: "Veröffentlichungsdatum",
  modificationDate: "Zuletzt geändert",
  commercialConsent: "Einwilligung zu Marketingzwecken",
  lastLogin: "Letzte Anmeldung",
  accepted: "Akzeptiert",
  notAccepted: "Abgelehnt",
  phone: "Telefon",
  password: "Passwort",
  oldPassword: "Aktuelles Passwort",
  newPassword: "Neues Passwort",
  forgotPassword: "Passwort vergessen?",
  confirmPassword: "Passwort bestätigen",
  all: "Alle",
  pswdHelp:
    "Das Passwort muss mindestens 8 Zeichen lang sein und mindestens ein Sonderzeichen enthalten.",
  receivingCommercial:
    "Durch Ankreuzen dieses Feldes erkläre ich mich damit einverstanden, Marketingmitteilungen von iizenglish zu erhalten.",
  termsAccepted: "Ich akzeptiere die",
  termsAndConditions: "Allgemeinen Geschäftsbedingungen",
  termsAndConditionsAcceptedHelp:
    "Sie müssen die Allgemeinen Geschäftsbedingungen akzeptieren.",
  registrationTitle: "Registrieren Sie sich bei iizenglish",
  restPasswordTitle: "Setzen Sie Ihr Passwort zurück!",
  resetPasswordRequested:
    "Ihre Anfrage zur Zurücksetzung des Passworts wurde erfolgreich bearbeitet (die E-Mail kann bis zu einer Minute benötigen. Bitte überprüfen Sie auch Ihren Spam-Ordner).",
  submit: "Bestätigen",
  loading: "Wird geladen…",
  thanksJoining: "Vielen Dank, dass Sie sich bei iizenglish angemeldet haben!",
  welcomeAdminHome: "Willkommen im Admin-Bereich",
  mailSent: "Eine E-Mail wurde an Sie gesendet",
  newMailSent: "Eine neue E-Mail wurde an Sie gesendet.",
  validationExpired:
    "Dieser Bestätigungslink ist abgelaufen. Bitte geben Sie Ihre E-Mail-Adresse erneut ein:",
  requestExpired: "Ihre Anfrage ist abgelaufen.",
  signup: "Konto erstellen",
  login: "Anmelden",
  logout: "Abmelden",
  success: "Erfolgreich",
  error: "Fehler",
  warning: "Hinweis",
  mandatoryField: "Dieses Feld ist erforderlich.",
  mandatoryIntegerField:
    "Dieses Feld ist erforderlich und muss eine ganze Zahl sein.",
  maxLengthField:
    "Dieses Feld darf nicht mehr als {maxLength} Zeichen enthalten.",
  dynamicMandatoryField: "Das Feld {field} ist erforderlich.",
  dynamicErrorField: "Das Feld {field} ist ungültig.",
  passwordTitle: "Erstellen Sie Ihr Passwort",
  newPasswordTitle: "Geben Sie Ihr neues Passwort ein",
  mandatoryFieldWithFormat:
    "Dieses Feld ist erforderlich und muss das richtige Format haben.",
  parameters: "Einstellungen",
  search: "Suchen",
  tableOfContents: "Inhalt",
  train: "Üben",
  assign: "Zuweisen",
  enterKeyword: "Gib hier deine Stichwörter ein…",
  example: "Beispiel",
  audioNotSupported: "Ihr Browser kann Audiodateien nicht abspielen.",
  cancel: "Abbrechen",
  confirmDelete: "Ja, löschen",
  confirm: "Ja, ich bestätige",
  close: "Schließen",
  sendUserReminder: "Erinnerung senden",
  saveModification: "Änderungen speichern",
  reportBug: "Fehler melden",
  screenshot: "Screenshot",
  thatIs: "bis zum",
  noResult: "Keine Ergebnisse gefunden",
  connectingPleaseWait: "Anmeldung läuft, bitte warten",
  none: "Keine",
  passwordsDontMatch: "Die Passwörter stimmen nicht überein.",
  validate: "Bestätigen",
  userPersonalData: "Personenbezogene Daten",
  comment: "Kommentar",
  level: "Niveau | Niveaus",
  levelUnquantified: "Niveau(s)",
  optional: "Optional",
  nonStudentAccountAlreadyExists:
    "Für diese E-Mail-Adresse besteht bereits ein Lehrerkonto.",
  accountAlreadyExistsBadParams:
    "Bitte überprüfen Sie die Schülerdaten; diese E-Mail-Adresse wird bereits für einen anderen Schüler verwendet.",
  duplicateEmail: "Diese E-Mail-Adresse wird mehrfach verwendet.",
  activationStatus: "Status",
  startDate: "Startdatum",
  endDate: "Abgabedatum",
  creationDate: "Erstellt am",
  missingStudentsLevel:
    "Einige Schüler haben kein Niveau zugewiesen und können auf diese Aufgabe nicht zugreifen.",
  numberShort: "Nr.",
  previous: "Zurück",
  next: "Weiter",
  finish: "Abgeben",
  nextStep: "Weiter",
  previousStep: "Zurück",
  yourSelection: "Ihre Auswahl",
  menuBack: "Zurück zum Menü",
  summary: "Inhalt",
  dynamicModel: "Vorlage {modelNumber}",
  instruction: "Anweisungen",
  instructionImage: "Klicken Sie auf ein Bild, um es zu vergrößern.",
  markScale: "Bewertungsskala",
  proposition: "Option | Optionen",
  question: "Frage | Fragen",
  answer: "Antwort | Antworten",
  part: "Teil | Teile",
  addQuestion: "Frage hinzufügen",
  addPart: "Teil hinzufügen",
  helpersActivated:
    "Bei {X} von {Y} richtigen Antworten wurde Hilfe verwendet. Jede Antwort, bei der Hilfe verwendet wurde, zählt nur zur Hälfte der Punkte.",
  help: "Hilfe",
  helpEnabled: "aktiviert. Diese Frage zählt nur zur Hälfte der Punkte.",
  preview: "Prévisualiser",
  reset: "Zurücksetzen",
  category: "Kategorie",
  chooseCategory: "Kategorie auswählen",
  grammar: "Grammatik",
  vocabulary: "Wortschatz",
  chooseChapter: "Kapitel auswählen",
  chooseSubchapter: "Select a section",
  position: "Reihenfolge",
  yes: "Ja",
  no: "Nein",
  publishedQuestion: "Veröffentlichen ?",
  publish: "Veröffentlichen",
  demoAvailableQuestion: "Als Demo verfügbar?",
  save: "Speichern",
  update: "Bearbeiten",
  extract: "Extrahieren",
  published: "Veröffentlicht",
  saveAndPublish: "Speichern und veröffentlichen",
  notPublished: "Nicht veröffentlicht",
  personalInformation: "Profil",
  pleaseEnter: "Bitte zur Bestätigung eingeben",
  remainingTime: "Verbleibende Zeit",
  dayShort: "t",
  individual: "Individuell",
  chapters: "Kapitel",
  resetTableOfContent: "Inhalt zurücksetzen",
  status: "Status",
  activated: "Aktiv",
  notActivated: "Inaktiv",
  detail: "Details",
  delete: "Löschen",
  message: "Nachricht",
  send: "Senden",
  city: "Stadt",
  zip: "Postleitzahl",
  address: "Adresse",
  name: "Name",
  toManyRequests:
    "Sie haben heute zu viele Nachrichten gesendet. Bitte versuchen Sie es später erneut.",
  messageSent: "Nachricht gesendet.",
  dataContactMessage:
    "Die über dieses Formular erhobenen Daten werden von IIZENGLISH verarbeitet, um Ihre Kontaktanfrage zu bearbeiten.",
  dataSubscriptionMessage:
    "Die über dieses Formular erhobenen Daten werden von IIZENGLISH verarbeitet, um Ihre Registrierung auf der Website durchzuführen.",
  privacyPolicyMessage:
    "Erfahren Sie mehr darüber, wie wir Ihre Daten verarbeiten und welche Rechte Sie haben.",
  organization: "Schule",
  filters: "Filter",
  downloadInPdf: "Als PDF herunterladen",
  view: "Vorschau",
  actions: "Aktionen",
  newContentAvailable: "Update verfügbar.",
  pleaseRefresh: "Aktualisieren",
  validationEmailSended:
    "Eine neue Aktivierungs-E-Mail wurde gesendet. Mit dieser können Sie Ihr Passwort erstellen.",
  checkSpam: "(Bitte überprüfen Sie auch Ihren Spam-Ordner.)",
  invitationNotAccepted:
    "Sie wurden zu iizenglish eingeladen, haben die Einladung jedoch noch nicht angenommen.",
  setPasswordMailResent:
    "Eine neue Einladungs-E-Mail wurde gesendet. Mit dieser können Sie Ihr Passwort festlegen und Ihr Konto aktivieren.",
  studentEmailNotDelivered: "E-Mail nicht zugestellt",
  checkStudentEmail: "Bitte überprüfen Sie die E-Mail-Adresse des Schülers.",
  definitiveAction: "Diese Aktion kann nicht rückgängig gemacht werden.",
  irreversible: "Diese Aktion kann nicht rückgängig gemacht werden.",
  areYouSure: "Sind Sie sicher, dass Sie fortfahren möchten?",
  ALL: "ALLE",
  verify: "Bestätigen",
  cookieBannerTitle: "Cookies bei iizenglish",
  cookieBannerLegal:
    "Wenn Sie diese Website weiter nutzen, stimmen Sie der Verwendung von Cookies zu, die für das ordnungsgemäße Funktionieren der Website unbedingt erforderlich sind. Wenn Sie mehr erfahren möchten, klicken Sie auf diesen",
  cookieDetailLink: "link",
  ok: "OK",
  activate: "Aktivieren",
  generate: "Generieren",
  numberOfLines: "Anzahl der Zeilen:",
  file: "Datei:",
  type: "Typ",
  understood: "Verstanden",
  scrollToViewMore: "Scrollen Sie horizontal, um mehr anzuzeigen",
  globalParameter: "Globale Einstellungen",
  parameter: "Einstellung",
  description: "Beschreibung",
  value: "Wert",
  class: _class,
  assignment: _assignment,
  account: _account,
  exercise: _exercise,
  blogs: _blogs,
  form: _form,
  subscription: _subscription,
  schools: _schools,
  notifications: _notifications,
  tabuleoSubscription: _tabuleoSubscription,
  garSubscription: _garSubscription,
  students: _students,
  country: _country,
  teachers: _teachers,
  payment: _payment,
  resource: _resource,
  purge: _purge,
  mockExams: _mockExams,
  twoFactorAuth: _twoFactorAuth,
  session: _session,
  maintenance: _maintenance,
};

export default message;
